import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-notification-badge',
    templateUrl: './notification-badge.component.html',
    styleUrls: ['./notification-badge.component.css'],
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationBadgeComponent {
  constructor() { }

  @Input() count: number = 0;
  @Input() warningStatus: boolean = false;
}
